import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import AutoRenew from 'material-ui/svg-icons/action/autorenew';
import FontBar from './FontBar.jsx';
import Loading from '../helpers/Loading.jsx';
import Headline from './Headline.jsx';
import FontDescriptions from './FontDescriptions.jsx';
import Quotes from './Quotes.jsx';
import News from './News.jsx';
import Panagram from './Panagram.jsx';
import Passages from './Passages.jsx';
import Elements from './elements/Elements.jsx';
import FontsAPI from '../../api/FontsAPI';
import { getFontUrlName } from '../../helpers/fonts';
import { connect } from 'react-redux';
import EmbedContainer from './embed/EmbedContainer.jsx';
import './Generator.css';
const SPACE_KEY = 32;

const mapStateToProps = (state) => {
  return {
    lockedPrimary: state.lockedPrimary,
    lockedSecondary: state.lockedSecondary
  }
}

class Generator extends Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.generate = this.generate.bind(this);
  }

  handleKeyDown (event) {
    switch( event.keyCode ) {
      case SPACE_KEY:
        event.preventDefault();
        this.generate();
        break;
      default:
        break;
    }
  }

  componentWillMount(){
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  generate() {
    const {
      lockedPrimary,
      lockedSecondary
    } = this.props;

    if (lockedPrimary && lockedSecondary) {
      // if both fonts are locked, don't generate a new pair
      return
    }

    const response = FontsAPI.getRandomPair();
    const {
      primaryName,
      secondaryName,
    } = response;

    const primaryNameUrl = getFontUrlName(primaryName);
    const secondaryNameUrl = getFontUrlName(secondaryName);

    if (lockedPrimary) {
      browserHistory.push('/' + lockedPrimary + '+' + secondaryNameUrl);
    }
    else if (lockedSecondary) {
      browserHistory.push('/' + primaryNameUrl + '+' + lockedSecondary);
    }
    else {
      browserHistory.push('/' + primaryNameUrl + '+' + secondaryNameUrl);
    }
  }

  renderFonts() {
    return (
      <div>
        <Headline />
        <FontDescriptions />
        <Passages />
        <Elements />
        <News />
        <Panagram />
        <Quotes />
      </div>
    )
  }

  render () {
    const {
      loading
    } = this.props;

    return (
      <div>
        <FontBar loading={loading} />
        <EmbedContainer />
        <div className="body-wrapper">
          {loading
            ? <Loading />
            : this.renderFonts()}
        </div>
        <FloatingActionButton className='generate-new-button'
          onClick={this.generate}>
          <AutoRenew className="generate-new-icon" />
        </FloatingActionButton>
      </div>
    )
  }
}

export default Generator = connect(mapStateToProps, undefined)(Generator);



// WEBPACK FOOTER //
// ./src/components/generator/Generator.jsx